import { Component, OnInit } from '@angular/core';

import { BeesFooterComponent }
  from "../bees-footer/bees-footer.component";

import { BeesHeaderComponent }
  from "../bees-header/bees-header.component";

import {
  NgIf,
  ViewportScroller
}
  from '@angular/common';

import {
  FormsModule
}
  from '@angular/forms';

import {
  Router
}
  from '@angular/router';

import {
  FlyingbeesService
}
  from '../flyingbees.service';

@Component({

  selector:
    'app-page-spices',

  standalone: true,

  imports: [

    BeesFooterComponent,

    FormsModule,

    BeesHeaderComponent,

    NgIf

  ],

  templateUrl:
    './page-spices.component.html',

  styleUrl:
    './page-spices.component.scss'

})

export class PageSpicesComponent
  
implements OnInit {

  activeSection =
    'pepper';

  showPopup =
    true;

  pin1 = '';
  pin2 = '';
  pin3 = '';
  pin4 = '';

  errorMsg = '';

  constructor(

    private scroller:
      ViewportScroller,

    private manas:
      FlyingbeesService,

    private router:
      Router

  ) { }

  /* INIT */

  ngOnInit() {

    const access =

      localStorage.getItem(

        'page_access'

      );

    if (
      access === 'true'
    ) {

      this.showPopup =
        false;

    }

  }

  /* SCROLL */

  goToSection(
    section: string
  ) {

    this.activeSection =
      section;

    this.scroller
      .scrollToAnchor(
        section
      );

  }

  /* OTP MOVE */

  moveNext(

    event: any,

    next?:
      HTMLInputElement

  ) {

    if (

      event.target.value

      &&

      next

    ) {

      next.focus();

    }

    const code =

      this.pin1 +

      this.pin2 +

      this.pin3 +

      this.pin4;

    if (
      code.length === 4
    ) {

      this.checkPassword();

    }

  }

  /* PASSWORD CHECK */

  checkPassword() {

    const code =

      this.pin1 +

      this.pin2 +

      this.pin3 +

      this.pin4;

    /* CLEAR OLD ERROR */

    this.errorMsg = '';

    this.manas

      .CheckPassword(
        code
      )

      .subscribe({

        next: (res: any) => {

          console.log(
            res
          );

          /* SUCCESS */

          if (
            res.status === 'success'
          ) {

            this.showPopup =
              false;

            /* SAVE ACCESS */

            localStorage.setItem(

              'page_access',

              'true'

            );

          }

          /* WRONG PASSWORD */

          else {

            this.errorMsg =

              'Invalid Password';

            this.clearPin();

            this.showPopup =
              true;

          }

        },

        error: (err) => {

          console.log(
            err
          );

          this.errorMsg =

            'Invalid Password';

          this.clearPin();

          this.showPopup =
            true;

        }

      });

  }
  /* CLEAR */

  clearPin() {

    this.pin1 = '';

    this.pin2 = '';

    this.pin3 = '';

    this.pin4 = '';

  }

  /* HOME */

  goHome() {

    this.router.navigate(
      ['/']
    );

  }

}